import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import Global from '../../../store/global-selectors';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';
import { ModalService } from 'ui-components/services/modal-service';
import { BulkPrintWarnContainer } from '../../../containers/bulk-print-warn-container';

export const ShowWarningStep = (state, jobId) => {
  return new Observable((observer) => {
    const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
    const { printedFulfillmentPlanIds = [], fulfillmentPlanIds } = jobData;
    const idsToPrint = fulfillmentPlanIds;

    const shouldUseQuickship = Global.selectSellerQuickshipAllowedForSeller(state) && Global.selectUserIsQuickshipEnabledForUser(state);
    const { showWarnings } = Global.selectUserQuickshipShouldShowErrorsOrWarnings(state);
    if (!printedFulfillmentPlanIds.length || (shouldUseQuickship && !showWarnings)) {
      observer.next([JobPipelineActions.updateJob(jobId, { idsToPrint }), JobPipelineActions.goForwardOnJob(jobId)]);
      observer.complete();
      return;
    }

    const modalId = ModalService.launchModal({
      component: BulkPrintWarnContainer,
      onCancel: () => {
        observer.next(JobPipelineActions.exitJobPipeline(jobId));
      },
      onClose: () => observer.complete(),
      props: {
        yes: () => {
          observer.next([JobPipelineActions.updateJob(jobId, { idsToPrint }), JobPipelineActions.goForwardOnJob(jobId)]);
        },
        no: () => {
          observer.next([
            JobPipelineActions.updateJob(jobId, {
              idsToPrint: idsToPrint.filter((id) => !printedFulfillmentPlanIds.includes(id)),
            }),
            JobPipelineActions.goForwardOnJob(jobId),
          ]);
        },
      },
    });

    observer.next(JobPipelineActions.updateJob(jobId, { modalId }));
  }).pipe(
    mergeMap((next) => {
      return Array.isArray(next) ? of(...next) : of(next);
    }),
  );
};
